import { FC, memo } from 'react';
// mui components
import { Avatar, Grid, Typography } from '@mui/material';
// components
import { isVideo } from 'components/uploaded-images/helpers';
import { MediaVideoItem } from '../media-video-item/media-video-item';
import DefaultAvatar from 'components/default-avatar';
// custom hooks
import { useElementDimensions } from 'hooks/useElementDimensions';
// api
import { IActivityFeedMedia, TActivityFeedMediaWithIndex } from 'redux-store/api/activity-feed';
// helpers
import { getImageBySize } from 'utils/helpers';
// styles
import { styles } from './styles';

interface IProps {
  mediaItem: [string, TActivityFeedMediaWithIndex[]];
  handleOpenGallery: (idx: number) => void;
}

export const IMAGE_HEIGHT = 133;

const MediaItem: FC<IProps> = ({ mediaItem: [createdAt, items], handleOpenGallery }) => {
  const { width, ref } = useElementDimensions();

  const renderProfile = (profile: IActivityFeedMedia['profile']) => {
    return (
      <Grid sx={styles.profileContainer}>
        {profile?.avatar?.url ? (
          <Avatar
            alt="profile avatar"
            variant="square"
            sx={styles.profile}
            src={getImageBySize(profile.avatar.url, 19, 19, false)}
          />
        ) : (
          <DefaultAvatar
            initials={`${profile?.firstName?.[0]}${profile?.lastName?.[0]}`}
            alt="profile avatar"
            variant="square"
            sx={styles.profile}
          />
        )}
      </Grid>
    );
  };

  return (
    <Grid sx={styles.container}>
      <Typography sx={styles.typo}>{createdAt}</Typography>
      <Grid sx={styles.itemsContainer} ref={ref}>
        {items.map(({ id, url, mimeType, profile, index, options }, idx) => {
          const isVideoItem = isVideo(mimeType);

          if (isVideoItem) {
            return (
              <MediaVideoItem
                thumbnailUrl={options?.previewUrl}
                onClick={() => handleOpenGallery(index)}
                width={width}
                key={id}
              />
            );
          }

          return (
            <Grid
              key={id}
              sx={{
                height: `${IMAGE_HEIGHT}px`,
                background: `url(${getImageBySize(url, (width - 8) / 2, IMAGE_HEIGHT, false)})`,
                ...styles.imageContainer,
              }}
              onClick={() => handleOpenGallery(index)}
            >
              {renderProfile(profile)}
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default memo(MediaItem);
